var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLabel = function SvgLabel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 73 21",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h72.5l-4.73 10.5L72.5 21H0V0Z",
    fill: "#309"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.292 13.212H14.46L13.776 15H12l3.288-8.46h1.308l3.3 8.46h-1.884l-.72-1.788Zm-2.34-1.404h1.92l-.648-1.752-.288-1.332h-.06l-.288 1.344-.636 1.74Zm7.97-.36h-.468V15h-1.776V6.6h1.776v3.696l.42-.18 2.52-3.516h2.028l-2.664 3.516-.696.456.72.48L27.83 15h-2.196l-2.712-3.552Zm13.691 5.04h-1.26L35.161 15H28.73V6.6h1.776v6.84h3.168V6.6h1.776v6.84h1.164v3.048Zm6.35-6.12L43.06 9.3H43l-.612 1.08L38.944 15h-1.32V6.6H39.4v4.524l-.12 1.116h.072L40 11.124 43.408 6.6h1.332V15h-1.776v-4.632Zm8.673 0 .096-1.068h-.06l-.612 1.08L47.616 15h-1.32V6.6h1.776v4.524l-.12 1.116h.072l.648-1.116L52.08 6.6h1.332V15h-1.776v-4.632Z",
    fill: "#fff"
  })));
};
export default SvgLabel;